<template>
	<v-card class="tab-card">
		<h2>Notification</h2><br>
      <div v-if="notification_list.length > 0">
        <v-card  v-for="item in notification_list" :key="item.id" class="tab-card mb-2">
          <div class="">
            <div class="align-content-center d-flex justify-space-between" >
              <strong>{{item.form_name}}</strong><div style="text-align:right">{{ item.created_at}}  
                <v-btn icon  @click="deletenotification(item.id)">
                <v-img
                max-height="23"
                max-width="19"
                :src=" delete_pic"
                :lazy-src=" delete_pic"
                > </v-img>
              </v-btn>	</div>
            </div>
            
            {{item.message}}
          </div>
        </v-card>
      </div>
      <div v-else style="text-align:center">
        <span>No record(s) found</span>
      </div>  
</v-card>
  
    

</template>

<script>
  import { GET_NOTIFICATION_LIST, DELETE_NOTIFICATION_DATA } from "../../store/actions.type";
  export default {
   
    data () {
      return {
        tab: null,
        text: 'text1',
        tabName: 'annual',
        current_plan_type:'',
        notification_list:[],
        delete_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'delete.png'
      }
    },
    mounted(){
    	this.getNoticationList();
    },
    methods:{
      CheckTab(tabName) {
        this.tabName = tabName;
      },
      getNoticationList() {
        this.$loading(true);
        let cognito_idp = atob(localStorage.getItem('cognito_idp'));
        this.$store.dispatch(GET_NOTIFICATION_LIST, {
          data: {
              aws_cognito_id: cognito_idp,
          },
          api: "get-notification-list",
        })
        .then(() => {
        	this.notification_list = this.$store.getters.getNotificationList.data.notification_list
        	console.log(this.notification_list)
            this.$loading(false);
        })
        .catch(() => {
            this.$loading(false);
        });
      },
       deletenotification(id){
        swal
        .fire({
          title: "Are you sure, you want to delete this data?",
          showCancelButton: true,
          confirmButtonColor: `#051d42`,
          confirmButtonText: `YES`,
          cancelButtonColor: `#f19700`,
        })
        .then(result => {
          if (result.isConfirmed) {
            let cognito_idp = atob(localStorage.getItem('cognito_idp'));
            let user_name =  this.$store.getters.getUserDetails.user_name;
            this.$store.dispatch(DELETE_NOTIFICATION_DATA, {
              data: {
                aws_cognito_id: cognito_idp,
                id:id,
              },
              api: "delete-notification",
            })
             .then(() => {
              this.getNoticationList();
              Toast.fire({
                icon: 'success',
                title: 'Data deleted successfully.'
              })
            });

           } else if (result.isDenied) {
            Swal.fire("Changes are not saved", "", "info");
          }
        });
      },
    },
  }
</script>